import { Component, ElementRef, Inject, Renderer2, ViewChild } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { TranslateService } from '@ngx-translate/core';
import { IdexService } from 'app/idex.service';
import { Toast } from 'app/shared/toast/toast';

@Component({
  selector: 'app-upload-certificate',
  templateUrl: './upload-certificate.component.html',
  styleUrls: ['./upload-certificate.component.css']
})
export class UploadCertificateComponent {
   @ViewChild('fileUpload') fileUpload: any;
   @ViewChild('filename') filename: ElementRef;
   storepass = '';
   file: File;
   certData: any;
   type: string;
   tin: string;
   id: string;
   privateKey: string;

   loading: boolean;
   visible = false;
   visibleK = false;

   certType = /application\/x-java-keystore|x-pkcs12/;
   size = 2097152;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, public service: IdexService,
              private dialogRef: MatDialogRef<UploadCertificateComponent>, private toast: Toast,
              private renderer: Renderer2, private translate: TranslateService) {

      if (data) {
         this.type = data.type;
         this.tin = data.tin;
         this.id = data.id;
      }
  }

   selectCert(event: any) {
      const file = event.target.files[0];
      const ext = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
      if (ext !== 'jks' && ext !== 'p12') {
         this.translate.get('alert.cert_error').subscribe(s => {
            this.toast.error(s);
         });
         return;
      }
      if (event.target.files && event.target.files[0].size > this.size) {
         this.translate.get('alert.cert_error').subscribe(s => {
            this.toast.error(s);
         });
         return;
      }
      if (event.target.files && event.target.files[0] && event.target.files[0].size < this.size) {
         this.file = event.target.files[0];
         this.loadPreview();
      }
   }

   onDragOver(event: DragEvent) {
      const hasFiles = true;
      if (hasFiles) {
            event.preventDefault();
            event.stopPropagation();
            event.dataTransfer.dropEffect = 'copy';
         }
   }

   onDrop(event: DragEvent) {
      event.preventDefault();
      event.stopPropagation();
      const file = event.dataTransfer.items[0].getAsFile();
      const ext = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
      if (ext !== 'jks' && ext !== 'p12') {
         this.translate.get('alert.cert_error').subscribe(s => {
            this.toast.error(s);
         });
         return;
      } else {
         if (event.dataTransfer.items[0].getAsFile().size > this.size) {
            this.translate.get('alert.cert_error').subscribe(s => {
               this.toast.error(s);
            });
            return;
         }
         if (event.dataTransfer && event.dataTransfer.items[0].getAsFile()) {
            this.file = event.dataTransfer.items[0].getAsFile();
            this.loadPreview();
         }
      }
   }

   private loadPreview() {
      this.renderer.setProperty(this.filename.nativeElement, 'innerHTML', this.file.name);
   }

   uploadFile(): void {
      this.service.uploadCertification(this.file, this.storepass, this.type, this.tin, this.id, this.privateKey)
         .subscribe(data => {
            this.dialogRef.close(data);
         }, error => {
            this.toast.error(error);
         });
  }

}
